import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getLocationType } from './selectors.js'
import NotFoundPage from './components/NotFoundPage.js'
import HomePage from './components/HomePage.js'
import FetchSurveyPage from './components/FetchSurveyPage.js'
import SubmitPage from './components/SubmitPage.js'
import SubmitFailedPage from './components/SubmitFailedPage.js'
import ThanksPage from './components/ThanksPage.js'
import SurveyPage from './components/SurveyPage.js'
import UnsupportedBrowserMessage from './components/UnsupportedBrowserMessage.js'

const isOldIE = navigator.userAgent.indexOf('MSIE') >= 0

class App extends Component {
  render() {
    if (isOldIE) return <UnsupportedBrowserMessage />

    const { locationType } = this.props
    switch (locationType) {
      case 'page/home':
        return <HomePage />
      case 'currentQuestionId/set':
        return <SurveyPage />
      case 'surveyState/fetching':
        return <FetchSurveyPage />
      case 'formState/submit':
        return <SubmitPage />
      case 'formState/submitFailed':
        return <SubmitFailedPage />
      case 'formState/submitted':
        return <ThanksPage />
      default:
        return <NotFoundPage />
    }
  }
}

const mapStateToProps = state => ({
  locationType: getLocationType(state),
})

export default connect(mapStateToProps)(App)



// WEBPACK FOOTER //
// ./src/App.js